<template>
  <div id="app-index">
    <home-head></home-head>
    <home-nav></home-nav>
    <home-carousel></home-carousel>
    <home-welfare></home-welfare>
    <home-project></home-project>
    <!-- <home-activity></home-activity> -->
    <home-footprint></home-footprint>
    <home-info></home-info>
    <home-foot ref="foot"></home-foot>
    <floating-button></floating-button>
    <!-- <div class="btn-left animated fadeInUpBig" @click="goDonate">
      <p class="iconfont">&#xe65a;</p>
      <h5>我要捐赠</h5>
    </div>
    <div class="btn-right animated fadeInUpBig" @click="goApply">
      <p class="iconfont">&#xe665;</p>
      <h5>申请救助</h5>
    </div>-->
  </div>
</template>
<script>
import animate from "animate.css";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import homeCarousel from "./home_carousel";
import homeWelfare from "./home_welfare";
import homeProject from "./home_project";
import homeActivity from "./home_activity";
import homeFootprint from "./home_footprint";
import homeInfo from "./home_info";
import homeFoot from "../Public/foot";
import floatingButton from "../Public/floatingButton";

export default {
  components: {
    homeHead,
    homeNav,
    homeCarousel,
    homeWelfare,
    homeProject,
    homeActivity,
    homeFootprint,
    homeInfo,
    homeFoot,
    floatingButton
  },
  data() {
    return {
      pStyle: -1,
      pText: "",
      pText1: ""
    };
  },

  created() {
  },
  methods: {
    goDonate() {
      window.open(this.$refs.foot.webInfo.donation_url);
    },
    goApply() {
      this.$router.push({ name: "applyIndex" });
    },
    changeActive(id) {
      this.pStyle = id;
      if (id == 1) {
        this.pText = "我要捐赠";
      }
      if (id == 2) {
        this.pText1 = "救助申请";
      }
    },
    removeActive(id) {
      this.pStyle = id;
      this.pText = "";
      this.pText1 = "";
    },
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home/home_index.vue